import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
// import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        payments_pending: null,
        payments_acepted: null,
        payments_rejected: null,
        payment: {id: null, amount: null, b64: null},
        view: false,
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchPayments({commit}, pagination) {
        const response = await axios.post(`/fastmarket/admin/payment?page=${pagination.currentPage}`, {...pagination});
        commit('SET_PAYMENTS', {result: response.data, index: pagination.state})
    },
    async setPayment({commit}, data) {
        commit('SET_PAYMENT', data)
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async createOrUpdate({commit, state}) {
        await axios.post('/b2b/admin/config/update', {
            suggestedPriceRules: state.config.suggestedPriceRules,
            daysInStock: state.config.daysInStock,
            safetyStock: state.config.safetyStock,
        });
    },
    async validPayment({commit}, data) {
        const response = await axios.post(`/fastmarket/admin/payment/valid`, data);
        return response.data.success
    },

}

export const mutations = {
    updateField,
    SET_PAYMENTS(state, {result, index }) {
        state[`payments_${index}`] = {
            items: result.data,
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
    },
    SET_PAYMENT(state, data) {
        state.payment = state[`payments_${data.state}`].items.find((i) => i.id == data.id)

        state.view = data.view
    }
}